import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  Box, Card, makeStyles, Container, CardContent,
  Grid, TextField, MenuItem, InputLabel, CardHeader, Button, Checkbox,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination,
  FormHelperText
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import CreatePDF from '../Pages/CreatePdf';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  
  tableHeader: {
    fontWeight: 'bold',
    borderBottom: '1px solid #e0e0e0',
    padding: '16px'
  },
  tableCell: {
    padding: '16px',
    borderBottom: '1px solid #e0e0e0'
  },
  rowSelected: {
    backgroundColor: '#e8f0fe !important' 
  },
  errorText: {
    color: '#f44336',
    fontSize: '0.75rem',
    marginTop: '3px',
    marginLeft: '14px'
  }
}));

const screenCode = "GENERATESUPPLIERQR";
export default function SupplierQRListing(props) {
  const classes = useStyles();
  const alert = useAlert();
  const navigate = useNavigate();
  const componentRef = useRef();

  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [routes, setRoutes] = useState([]);
  const [supplierQRList, setSupplierQRList] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    registrationNumber: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [supplierData, setSupplierData] = useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [istableHidden, setIstableHidden] = useState(true);
  const [savedTags, setSavedTags] = useState([]);
  const [currentFilters, setCurrentFilters] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    registrationNumber: ''
  });
 const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(5);
 useEffect(() => { trackPromise(getPermission()); }, []);
  useEffect(() => { 
  if (supplierQRList.groupID > 0) {
    trackPromise(getFactoriesForDropDown(supplierQRList.groupID));
  } else {
    setFactories(null);
    setSupplierQRList(prev => ({ 
      ...prev, 
      factoryID: '0',
      routeID: '0'
    }));
  }
}, [supplierQRList.groupID]);

 useEffect(() => {
  if (supplierQRList.factoryID > 0) {
    trackPromise(getRoutesByFactoryID(supplierQRList.factoryID));
  } else {
    setRoutes([]);
    setSupplierQRList(prev => ({ ...prev, routeID: '0' }));
  }
}, [supplierQRList.factoryID]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); 
  };

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGENERATESUPPLIERQR');
    if (isAuthorized === undefined) navigate('/404');
    
    setPermissions({
      isGroupFilterEnabled: permissions.find(p => p.permissionCode == 'GROUPDROPDOWN') !== undefined,
      isFactoryFilterEnabled: permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN') !== undefined,
    });

    setSupplierQRList({
      ...supplierQRList,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getFactoriesForDropDown(groupId) {
    const factory = await services.getFactoryByGroupID(groupId);
    setFactories(factory);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getRoutesByFactoryID(factoryID) {
    var response = await services.getRoutesForDropDown(factoryID);
    setRoutes(response);
  }

  async function getSuppliersByFilters(values) {
    setPage(0);
    setSelectedSuppliers([]);
    setSavedTags([]);
    
    var result = await services.getSuppliersByFilters(
      values.groupID, values.factoryID,
      values.routeID, values.registrationNumber
    );
    if (result.length == 0) {
      alert.error("NO RECORDS TO DISPLAY");
      setSupplierData([]);
      setIstableHidden(true);
    } else {
      setSupplierData(result);
      setIstableHidden(false);
    }
    setCurrentFilters({...values});
  }

  const getNames = () => {
    const factoryLabel = factories ? factories[supplierQRList.factoryID] : "";
    const routeLabel = routes ? routes[supplierQRList.routeID] : "";
    return { factoryLabel, routeLabel };
  };

  function handleSelectOne(row) {
    const { factoryLabel, routeLabel } = getNames();
    const itemString = JSON.stringify({
      regNo: String(row.registrationNumber),
      name: String(row.name),
      factory: String(factoryLabel),
      route: String(routeLabel)
    });

    setSelectedSuppliers(prev =>
      prev.includes(itemString) ? prev.filter(x => x !== itemString) : [...prev, itemString]
    );
  }

  function handleSelectAll(e) {
    if (e.target.checked) {
      const { factoryLabel, routeLabel } = getNames();
      const allSelected = supplierData.map(row => JSON.stringify({
        regNo: String(row.registrationNumber),
        name: String(row.name),
        factory: String(factoryLabel),
        route: String(routeLabel)
      }));
      setSelectedSuppliers(allSelected);
    } else {
      setSelectedSuppliers([]);
    }
  }

  async function handleGenerateTags() {
    if (selectedSuppliers.length === 0) {
      alert.error("Please select at least one supplier");
      return;
    }
    const selectedObjects = selectedSuppliers.map(s => JSON.parse(s));
    const regNumbersOnly = selectedObjects.map(obj => obj.regNo);
    const model = {
      registrationNumbers: regNumbersOnly,
      groupID: parseInt(supplierQRList.groupID),
      factoryID: parseInt(supplierQRList.factoryID),
      routeID: parseInt(supplierQRList.routeID),
      createdBy: parseInt(tokenService.getUserIDFromToken())
    };
    try {
      const response = await services.createSupplierTags(model);
      if (response?.statusCode === "Success") {
        setSavedTags(selectedSuppliers);
        alert.success("QR codes generated successfully");
      } else {
        alert.error(response?.message || "Failed to generate");
      }
    } catch (error) {
      alert.error("An error occurred while generating QR codes");
    }
  }

  function isRowSelected(regNo) {
    return selectedSuppliers.some(s => JSON.parse(s).regNo === String(regNo));
  }

  function handleChange(e, setFieldValue) {
    const newValue = e.target.value;
    const fieldName = e.target.name;
    setFieldValue(fieldName, newValue);
    if (fieldName === 'groupID') {
      setSupplierQRList(prev => {
        const updatedState = { 
          ...prev, 
          [fieldName]: newValue,
          factoryID: '0',  
          routeID: '0'    
        };
        setFieldValue('factoryID', '0');
        setFieldValue('routeID', '0');
        if (newValue === '0') {
          setFactories(null);
        }
        setRoutes([]);
        
        return updatedState;
      });
    } 
    else if (fieldName === 'factoryID') {
      setSupplierQRList(prev => {
        const updatedState = { 
          ...prev, 
          [fieldName]: newValue,
          routeID: '0'
        };
        setFieldValue('routeID', '0');
        setRoutes([]);
        
        return updatedState;
      });
    }
    else {
      setSupplierQRList(prev => ({ ...prev, [fieldName]: newValue }));
    }
    const hasFilterChanged = 
      (fieldName === 'groupID' && currentFilters.groupID !== newValue) ||
      (fieldName === 'factoryID' && currentFilters.factoryID !== newValue) ||
      (fieldName === 'routeID' && currentFilters.routeID !== newValue) ||
      (fieldName === 'registrationNumber' && currentFilters.registrationNumber !== newValue);

    if (hasFilterChanged) {
      setIstableHidden(true);
      setSelectedSuppliers([]);
      setSavedTags([]);
      setPage(0); 
    }
  }

  const isDownloadEnabled = () => {
    if (savedTags.length === 0) return false;
    
    const allSavedInSelected = savedTags.every(savedTag => 
      selectedSuppliers.includes(savedTag)
    );
    
    const allSelectedInSaved = selectedSuppliers.every(selectedTag => 
      savedTags.includes(selectedTag)
    );
    return allSavedInSelected && allSelectedInSaved && selectedSuppliers.length > 0;
  };
  
  const isGenerateEnabled = () => {
      return selectedSuppliers.length > 0 && !isDownloadEnabled();
  };

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }
  
  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title="Generate Supplier QR">
        <Container maxWidth={false}>
          <Formik
            initialValues={supplierQRList}
            validationSchema={Yup.object({
              groupID: Yup.number()
                .min(1, 'Group is required')
                .required('Group is required'),
              factoryID: Yup.number()
                .min(1, 'Factory is required')
                .required('Factory is required'),
              routeID: Yup.number()
                .min(1, 'Route is required')
                .required('Route is required'),
            })}
            onSubmit={getSuppliersByFilters}
            enableReinitialize
          >
            {({ handleSubmit, values, errors, touched, setFieldValue, handleBlur }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title="Generate Supplier QR Code" />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink>Group *</InputLabel>
                          <TextField 
                            select 
                            fullWidth 
                            size='small' 
                            name="groupID" 
                            onChange={(e) => handleChange(e, setFieldValue)}
                            onBlur={handleBlur}
                            value={values.groupID} 
                            variant="outlined"
                            error={touched.groupID && Boolean(errors.groupID)}
                            disabled={!permissionList.isGroupFilterEnabled}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                          {touched.groupID && errors.groupID && (
                            <FormHelperText error className={classes.errorText}>
                              {errors.groupID}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink>Factory *</InputLabel>
                          <TextField 
                            select 
                            fullWidth 
                            size='small' 
                            name="factoryID" 
                            onChange={(e) => handleChange(e, setFieldValue)}
                            onBlur={handleBlur}
                            value={values.factoryID} 
                            variant="outlined"
                            error={touched.factoryID && Boolean(errors.factoryID)}
                            disabled={!permissionList.isFactoryFilterEnabled}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                          {touched.factoryID && errors.factoryID && (
                            <FormHelperText error className={classes.errorText}>
                              {errors.factoryID}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink>Route *</InputLabel>
                          <TextField 
                            select 
                            fullWidth 
                            size='small' 
                            name="routeID" 
                            onChange={(e) => handleChange(e, setFieldValue)}
                            onBlur={handleBlur}
                            value={values.routeID} 
                            variant="outlined"
                            error={touched.routeID && Boolean(errors.routeID)}
                          >
                            <MenuItem value="0">--Select Route--</MenuItem>
                            {generateDropDownMenu(routes)}
                          </TextField>
                          {touched.routeID && errors.routeID && (
                            <FormHelperText error className={classes.errorText}>
                              {errors.routeID}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink>Registration Number</InputLabel>
                          <TextField 
                            fullWidth 
                            size='small' 
                            name="registrationNumber" 
                            onChange={(e) => handleChange(e, setFieldValue)}
                            value={values.registrationNumber} 
                            variant="outlined" 
                          />
                        </Grid>
                        <Grid container justify="flex-end">
                          <Box pr={2} pt={2}>
                            <Button color="primary" variant="contained" type="submit">SEARCH</Button>
                          </Box>
                        </Grid>
                      </Grid>
                      <Box hidden={istableHidden} mt={4}>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell className={classes.tableHeader} style={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox 
                                  color="primary" 
                                  onChange={handleSelectAll} 
                                  checked={supplierData.length > 0 && selectedSuppliers.length === supplierData.length} 
                                  style={{ paddingLeft: 0 }}
                                />
                                <span style={{ marginLeft: '8px' }}>Select All</span>
                              </TableCell>
                              <TableCell className={classes.tableHeader}>Registration No</TableCell>
                              <TableCell className={classes.tableHeader}>Name</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {supplierData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                              <TableRow 
                                key={row.registrationNumber} 
                                className={isRowSelected(row.registrationNumber) ? classes.rowSelected : ''}
                              >
                                <TableCell className={classes.tableCell}>
                                  <Checkbox 
                                    color="primary" 
                                    checked={isRowSelected(row.registrationNumber)} 
                                    onChange={() => handleSelectOne(row)} 
                                    style={{ paddingLeft: 0 }}
                                  />
                                </TableCell>
                                <TableCell className={classes.tableCell}>{row.registrationNumber}</TableCell>
                                <TableCell className={classes.tableCell}>{row.name}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={supplierData.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                          labelRowsPerPage="Rows per page:"
                          labelDisplayedRows={({ from, to, count }) => 
                            `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
                          }
                        />
                      </TableContainer>
                      <Box display="flex" justifyContent="flex-end" p={2} mt={2}>
                        <Button 
                          color="primary" 
                          variant="contained" 
                          style={{ marginRight: '1rem' }} 
                          disabled={!isGenerateEnabled()} 
                          onClick={() => trackPromise(handleGenerateTags())}
                        >
                          Generate QR Codes
                        </Button>
                        <ReactToPrint
                          trigger={() => (
                            <Button 
                              color="primary" 
                              variant="contained" 
                              disabled={!isDownloadEnabled()}
                            >
                              Download (Print)
                            </Button>
                          )}
                          content={() => componentRef.current}
                          onAfterPrint={() => {
                            setSavedTags([]);
                            setSelectedSuppliers([]);
                          }}
                        />
                      </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
      <div style={{ display: 'none' }}>
        <CreatePDF ref={componentRef} savedRegistrationNumbers={savedTags} />
      </div>
    </Fragment>
  );
}